import loadable from '@loadable/component';
import { WithConditionalHydration } from '../../../../WithConditionalHydration';
import { domainService } from '../../../../../domain/services/domainService';

const AdFakeLoadable = loadable(() => import('./AdFake'), {
  resolveComponent: components => components.AdFake,
  ssr: false
});

const condition = () =>
  domainService.isRunningOnCMS() ||
  domainService.isLocalDomain(window.location.hostname);

export const AdFake = WithConditionalHydration(AdFakeLoadable, condition);
